export function obterListaCTeServicoTipo() {
  return (
    [
      { label: 'Frete por Peso', value: 'Frete por Peso' },
      { label: 'Frete por Valor', value: 'Frete por Valor' },
      { label: 'Pedágio', value: 'Pedágio' },
      { label: 'Seguro', value: 'Seguro' },
    ]
  );
}
